import { FacilityQuery } from '~/config/generated/graphql';

export const handleFacilityPage = ({ facility }: Partial<FacilityQuery>) => ({
  ...facility
});
